var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"color":"blue","target":"_blank","href":_vm.url,"download":"","dark":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-microsoft-excel ")]),_c('span',[_vm._v("Descargar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }